import React, { Component, useCallback, useEffect, useState } from "react";
import classnames from "classnames";

import { Modal } from "../../components";

// Import styling
import "../../styles/components/_programs.scss";
import "../../styles/components/modals/_edit-program.scss";
import "../../styles/components/_programs.scss";
import { Help } from "../../api";
import { useDispatch, useSelector } from "react-redux";
import { setModalHelpClosed } from "../../actions/modals";

function Question({ itemClick, answerVisible, content, title }) {
  return (
    <section className={`accordion__question ${answerVisible ? "active" : ""}`}>
      <header
        className={`accordion__header ${answerVisible ? "is-active" : ""}`}
        onClick={itemClick}
      >
        <h5>{title}</h5>
        <i className="material-icons">add</i>
      </header>
      <div
        className="accordion__content"
        dangerouslySetInnerHTML={{ __html: answerVisible ? content : "" }}
      />
    </section>
  );
}

function HelpModal() {
  const dispatch = useDispatch();
  const { helpOpen } = useSelector((state) => state.modals);
  const downloadUrl = useSelector(
    (state) => state.terms.content.paper_form_full
  );

  const [openId, setOpenId] = useState(null);

  const [help, setHelpContent] = useState([]);

  useEffect(() => {
    const getFAQS = async () => {
      const res = await Help.getAll();
      setHelpContent(res?.data?.faqs || []);
    };
    getFAQS();
  }, []);

  const handleClose = useCallback(
    () => dispatch(setModalHelpClosed()),
    [dispatch]
  );

  // If there is a selected program, return the modal allowing the user to edit the donation
  return (
    <Modal isOpen={helpOpen} modalName="edit-program" onClose={handleClose}>
      <div className="remodal remodal--help" data-remodal-id="help-modal">
        <div className="help_content help_content--top">
          <h2>How can we help?</h2>

          <div className="accordion">
            <section className="accordion__question active">
              <header className="accordion__header">
                <h5>Prefer to use a paper form to donate?</h5>
                {downloadUrl && (
                  <a href={`${downloadUrl}`} className="btn__ghost save-button">
                    Download form to print
                  </a>
                )}
              </header>
            </section>
            {help.map((content) => {
              return (
                <Question
                  itemClick={() =>
                    setOpenId((prev) =>
                      prev === content.title ? null : content.title
                    )
                  }
                  answerVisible={openId === content.title}
                  key={content.title}
                  {...content}
                />
              );
            })}
          </div>
        </div>
        <div className="help_content help_content--bottom">
          <h2>Still need help? Get in touch.</h2>
          <div className="help_contact">
            <div className="help_contact__row">
              <div className="help_contact__column">
                <strong>Phone</strong>
              </div>
              <div className="help_contact__column">
                <span>1800 989 028</span> <br />
                <span>+61 2 9697 0313</span>
              </div>
            </div>
            <div className="help_contact__row">
              <div className="help_contact__column">
                <strong>Email</strong>
              </div>
              <div className="help_contact__column">
                <a className="text_link" href="mailto:support@afes.org.au">
                  support@afes.org.au
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default HelpModal;
